import { render, staticRenderFns } from "./EditArticleModal.vue?vue&type=template&id=1906d730&"
import script from "./EditArticleModal.vue?vue&type=script&lang=js&"
export * from "./EditArticleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports